import { render, staticRenderFns } from "./PatentBulletinAnalyseReportList.vue?vue&type=template&id=0b15f400&"
import script from "./PatentBulletinAnalyseReportList.vue?vue&type=script&lang=js&"
export * from "./PatentBulletinAnalyseReportList.vue?vue&type=script&lang=js&"
import style0 from "./PatentBulletinAnalyseReportList.vue?vue&type=style&index=0&id=0b15f400&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports